// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

// jsonp引入
import {VueJsonp} from 'vue-jsonp'
Vue.use(VueJsonp)

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{ak:'KG5QWyNXednF6ylkZWNFqE9Y'})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js